import { Button, Checkbox, Form, Input, message, Space } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { CloseOutlined } from "@ant-design/icons";

const defaultItem = { companyId: null, active: true, name: "", code: "", url: "" };

const Agent = ({ id, onClose, companyId }) => {
  const [item, setItem] = useState(defaultItem);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`Agent/${id}`)
        .then((data) => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch((e) => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } else {
      const initial = { ...defaultItem, companyId };
      form.setFieldsValue(initial);
      setItem(initial);
    }
  };

  useEffect(getData, [id, companyId]);

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  };

  const onSave = () => {
    form.validateFields().then(() => {
      setLoading(true);
      const payload = {
        ...item,
        companyId: item.companyId ?? companyId,
        name: item.name ?? "",
        code: item.code ?? "",
        url: item.url ?? "",
        active: item.active ?? true,
      };
      if (id) payload.id = id;
      const method = id ? "PUT" : "POST";
      serverFetch("Agent", { method, bodyData: payload })
        .then(() => onClose(true))
        .catch((e) => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" style={{ width: 640 }} onMouseDown={(e) => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>{id ? "Агент" : "Новый агент"}</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} />
          </div>
          <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
            <Form.Item name="active" valuePropName="checked" label=" ">
              <Checkbox>Активный</Checkbox>
            </Form.Item>
            <Form.Item name="name" label="Наименование">
              <Input placeholder="Наименование агента" />
            </Form.Item>
            <Form.Item name="url" label="URL">
              <Input placeholder="https://agent.example.com" />
            </Form.Item>
            <Form.Item name="code" label="Код (токен)">
              <Input placeholder="Токен авторизации" />
            </Form.Item>
            <Form.Item label=" ">
              <Space>
                <Button type="primary" onClick={onSave} loading={loading}>Сохранить</Button>
                <Button onClick={() => onClose(false)}>Закрыть</Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Agent;
